import PropTypes from 'prop-types';
import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { useLayout } from '../layout/context';
import ServicesFinder from './services';
import ShopsFinder from './ShopsFinder';
import { getShopByRegion } from './helpers';

const Finder = ({ introText, type, titleText }) => {
  const { allContentfulPageShop, allContentfulPageService } = useStaticQuery(
    graphql`
      query {
        allContentfulPageShop {
          nodes {
            navigation {
              path
            }
            shop {
              shopName
              shortAddress
              contactNumber
              contentful_id
              responseTapClass
              location {
                lat
                lon
              }
              region
            }
          }
        }
        allContentfulPageService {
          nodes {
            contentful_id
            navigation {
              path
            }
          }
        }
      }
    `
  );

  const { insideContainer } = useLayout();

  if (type === 'shops') {
    return (
      <ShopsFinder
        insideContainer={insideContainer}
        introText={introText}
        type={type}
        shops={allContentfulPageShop.nodes.reduce(getShopByRegion, [])}
        titleText={titleText}
      />
    );
  }
  return (
    <ServicesFinder
      insideContainer={insideContainer}
      introText={introText}
      type={type}
      services={allContentfulPageService.nodes}
      titleText={titleText}
    />
  );
};

Finder.propTypes = {
  introText: PropTypes.object,
  titleText: PropTypes.string,
  type: PropTypes.oneOf(['services', 'shops']),
};

export default Finder;

export const ServiceFinderAssembly = ({ contentfulData }) => (
  <Finder
    titleText={contentfulData.titleText}
    introText={contentfulData.introText}
    type="services"
  />
);

ServiceFinderAssembly.propTypes = {
  contentfulData: PropTypes.object,
};

export const ShopFinderAssembly = ({ contentfulData }) => (
  <Finder
    titleText={contentfulData.titleText}
    introText={contentfulData.introText}
    type="shops"
  />
);

ShopFinderAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
